// extracted by mini-css-extract-plugin
export default {"titleContainer":"Title_titleContainer__dtfzT","title":"Title_title__tRUHy","nameField":"Title_nameField__16068"};